import Vue from "vue";
import VueImg from "v-img-viewer";

Vue.use(VueImg);
